export default __webpack_public_path__ + "static/media/led it be animada.1964cae5.mp4";